<label class="switch">
    <input [class.colorCheckedbox]="specialColor" type="checkbox" [(ngModel)]="value" >
    <div [class.colorCheckedbox]="specialColor" class="slider round"></div>
    <div class="label" [ngStyle]="{'font-size': fontSize}">{{label}}</div>
    
</label>